import { StarPink, Accuracy80, TimeBlue } from '@common/assets';

export type ProgressType = 'neuroboost' | 'accuracy' | 'timespent';

type ProgressTheme = {
  color: string;
  progessColor: string;
  iconSrc: string;
  checkIcon: {
    bgColor: string;
    borderColor: string;
  };
};

const theme: Record<ProgressType, ProgressTheme> = {
  neuroboost: {
    color: '#FDE7F8',
    progessColor: '#F9B6EB',
    iconSrc: StarPink,
    checkIcon: {
      bgColor: '#EA0BBD',
      borderColor: '#BD139A',
    },
  },
  accuracy: {
    color: '#E7FAFF',
    progessColor: '#B7EFFF',
    iconSrc: Accuracy80,
    checkIcon: {
      bgColor: '#0DCBFF',
      borderColor: '#1BA5CB',
    },
  },
  timespent: {
    color: '#EAF0FE',
    progessColor: '#C1D2FC',
    iconSrc: TimeBlue,
    checkIcon: {
      bgColor: '#83A5FA',
      borderColor: '#6d94f7',
    },
  },
};

export const getProgressTheme = (type: ProgressType) => theme[type];
